import SvgIcon from "@mui/material/SvgIcon";

interface InsightsIconProps {
  htmlColor?: string;
  fontSize?: "small" | "inherit" | "large" | "medium";
}

export default function InsightsIcon({
  htmlColor,
  fontSize = "medium",
}: InsightsIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" fontSize={fontSize}>
      <path
        d="M22 13V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7.33008 14.4898L9.71008 11.3998C10.0501 10.9598 10.6801 10.8798 11.1201 11.2198L12.9501 12.6598C13.3901 12.9998 14.0201 12.9198 14.3601 12.4898L16.6701 9.50977"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M19.4802 15.8195L19.7602 16.3894C19.9002 16.6694 20.2502 16.9295 20.5602 16.9895L20.9402 17.0494C22.0802 17.2394 22.3502 18.0794 21.5302 18.9094L21.1802 19.2594C20.9502 19.4994 20.8202 19.9594 20.8902 20.2794L20.9402 20.4895C21.2502 21.8695 20.5202 22.3994 19.3202 21.6794L19.0602 21.5294C18.7502 21.3494 18.2502 21.3494 17.9402 21.5294L17.6802 21.6794C16.4702 22.4094 15.7402 21.8695 16.0602 20.4895L16.1102 20.2794C16.1802 19.9594 16.0502 19.4994 15.8202 19.2594L15.4702 18.9094C14.6502 18.0794 14.9202 17.2394 16.0602 17.0494L16.4402 16.9895C16.7402 16.9395 17.1002 16.6694 17.2402 16.3894L17.5202 15.8195C18.0602 14.7295 18.9402 14.7295 19.4802 15.8195Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
